import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { finishAuth } = useAuth();
  const { t } = useI18n();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    api.post("/auth/google", { session_id: sid })
      .then((r) => {
        window.history.replaceState(null, "", window.location.pathname);
        finishAuth(r.data.user);
        nav("/dashboard");
      })
      .catch(() => nav("/login"));
  }, [nav, finishAuth]);
  return <div className="min-h-screen grid place-items-center bg-[#0a0a0c] text-zinc-400 font-mono-ui text-sm">{t("auth.preparing")}</div>;
}
